import {useEffect} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import PrimitiveTypography, {primitiveTypographyDesign} from '@s-ui/react-primitive-typography'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CARD_CLASS = 'mt-NetMessageList-endChatCard'

const NetEndChatCard = ({chatId, onNewChat}) => {
  const {i18n, domain} = useSuiContext()
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {
    TRACKING_EVENT_NAMES: {NET_ASSISTANT_NEW_CHAT_CLICKED, NET_ASSISTANT_END_CONVERSTAION_VIEWED} = {},
    HIT_ORIGINS: {NET_ASSISTANT_END_CONVERSATION} = {}
  } = config.get('tracking')

  useEffect(() => {
    track({
      event: NET_ASSISTANT_END_CONVERSTAION_VIEWED,
      data: {hit_information: chatId}
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickNewChat = () => {
    onNewChat({hit_origin: NET_ASSISTANT_END_CONVERSATION})
    track({
      event: NET_ASSISTANT_NEW_CHAT_CLICKED,
      data: {hit_origin: NET_ASSISTANT_END_CONVERSATION, hit_information: chatId}
    })
  }

  return (
    <div className={BASE_CARD_CLASS}>
      <PrimitiveTypography design={primitiveTypographyDesign.BODY_1}>
        {i18n.t('NET.END_CHAT.LIMIT_TEXT')}
      </PrimitiveTypography>
      <AtomButton
        className={`${BASE_CARD_CLASS}-button`}
        design={atomButtonDesigns.OUTLINE}
        shape={atomButtonShapes.CIRCULAR}
        onClick={onClickNewChat}
      >
        {i18n.t('NET.END_CHAT.NEW_CONVERSATION_CTA')}
      </AtomButton>
    </div>
  )
}

NetEndChatCard.displayName = 'NetEndChatCard'
NetEndChatCard.propTypes = {
  chatId: PropTypes.string,
  onNewChat: PropTypes.func
}

export default NetEndChatCard
